ApiError = require 'network/api-error'
{ MinimalCanonicalCard } = require 'views/canonical-card/canonical-card-components'
ModelCache = require 'db/model-cache'
ModelLoader = require 'db/model-loader'
ModelCacheListener = require 'views/internal/model-cache-listener'
Util = require 'lib/util'
startDecayingInterval = require 'lib/util/decaying-interval'

class PopulatingMinimalCanonicalCard extends MinimalCanonicalCard

  constructor: (props) ->
    super(props)
    @state = @_loadAndHydrateState(props)
    if @props.isPolling
      @_cancelInterval = startDecayingInterval(@_loadModel.bind(@), {
        resetAfterMouseMove: true
        intervals: [
          {
            iterations: 2
            timeout: Util.getMs(seconds: 30)
          }
        ]
      })
    @_listenEvents()

  componentWillMount: ->
    @_mounted = true

  componentWillUnmount: ->
    @_mounted = false
    @_cancelInterval?()
    @props.clearModelListeners()

  _listenEvents: ->
    @props.listenTo 'add:Card, change:Card', (card) =>
      if card.id == @props.idCard
        @props.modelListener card, 'change', @_handleChange
        @_handleChange card

  _handleChange: (card) =>
    board = ModelCache.get('Board', card.get('idBoard') || @props.idBoard)
    @setState @_mapToState({
      card,
      board
    })

  _mapToState: ({ card, board }) ->
    badges = card?.get('badges')
    {
      cardName: card?.get('name') || @props.cardName
      cardDue: badges?.due || card?.get('due')
      cardDueComplete: badges?.dueComplete || card?.get('dueComplete')
      cardUrl: card?.get('url') || @props.cardUrl
      boardName: board?.get('name') || @props.boardName
      boardBgColor: board?.getPref('backgroundColor')
      boardBgBottomColor: board?.getPref('backgroundBottomColor')
      boardBgBrightness: board?.getPref('backgroundBrightness')
      boardBgImage: Util.smallestPreviewBiggerThan(board?.getPref('backgroundImageScaled'), 250, 130)?.url ? board?.getPref('backgroundImage')
      boardUrl: board?.get('url') || @props.boardUrl
      listName: card?.getList()?.get('name') || @props.listName
      isWide: @props.isWide
      tracking: @props.tracking
    }

  _loadModel: ->
    ModelLoader.loadCanonicalCardData(@props.idCard)
    .catch ApiError.NotFound, ApiError.Unauthorized, =>
      @_cancelInterval?()
      ModelLoader.loadBoardMinimal(@props.idBoard)

  _loadAndHydrateState: ({ idBoard, idCard }) ->
    card = ModelCache.get('Card', idCard)
    board = ModelCache.get('Board', card?.get?('idBoard') || idBoard)
    if !board || !card then @_loadModel()
    @_mapToState({ card, board })

module.exports = {
  PopulatingMinimalCanonicalCard: ModelCacheListener(PopulatingMinimalCanonicalCard)
}



// WEBPACK FOOTER //
// ./app/scripts/views/canonical-card/populating-canonical-card.coffee